// Single source of truth for list-table page sizes. Every table's rows-per-page
// dropdown and default page size come from here — do not hardcode these
// elsewhere.

export const ROWS_PER_PAGE_OPTIONS = [10, 25, 50, 100];

export const DEFAULT_PAGE_SIZE = 25;
